export default [{
  text: 'Százalék alkalmazása',
  code: 'contains_percentage_mark',
  value: '2'
}, {
  text: 'Átlagos szóhossz',
  code: 'avg_word_length',
  value: '5'
}, {
  text: 'Az első hely pozíciója',
  code: 'position_of_first_location',
  value: '6'
}, {
  text: 'Az első márka pozíciója',
  code: 'position_of_first_brand',
  value: '8'
}, {
  text: 'Az első negatív kifejezés pozíciója',
  code: 'position_of_first_negative_phrase',
  value: '10'
}, {
  text: 'Az első pozitív kifejezés pozíciója',
  code: 'position_of_first_positive_phrase',
  value: '12'
}, {
  text: 'Az első fontos téma pozíciója',
  code: 'position_of_first_topic',
  value: '14'
}, {
  text: 'Karakterek száma',
  code: 'char_length',
  value: '18'
}, {
  text: 'Növeld a negatív kifejezések számát',
  code: 'number_of_negative_phrases',
  value: '20'
}, {
  text: 'Csökkentsd a pozitív kifejezések számát',
  code: 'number_of_positive_phrases',
  value: '22'
}, {
  text: 'Pozitív vagy negatív kifejezések',
  code: 'sentiment_score',
  value: '24'
}, {
  text: 'Szavak száma',
  code: 'word_count',
  value: '29'
}, {
  text: '! jel alkalmazása',
  code: 'contains_exclamation_mark',
  value: '34'
}, {
  text: 'Növeld a pozitív vagy negatív kifejezések számát',
  code: 'number_of_sentiment_phrases',
  value: '35'
}, {
  text: 'Kérdés alkalmazása',
  code: 'contains_question_mark',
  value: '36'
}, {
  text: 'Növeld a márkák, tulajdonnevek vagy fontos témák számát',
  code: 'number_of_topics_and_entities',
  value: '37'
}, {
  text: 'Növeld a márkák számát',
  code: 'number_of_brands',
  value: '38'
}, {
  text: 'Növeld a helyek számát',
  code: 'number_of_locations',
  value: '39'
}, {
  text: 'Használj meglepő kifejezést',
  code: 'number_of_surprise',
  value: '40'
}, {
  text: 'Használj Fomo jellegű kifejezést',
  code: 'number_of_fomo',
  value: '41'
}, {
  text: 'Használj cselekvésre felhívó kifejezést',
  code: 'number_of_call_to_action',
  value: '42'
}, {
  text: 'Használj akcióra utaló kifejezést',
  code: 'number_of_sale',
  value: '43'
}, {
  text: 'Pozitív vagy negatív kifejezések relatív száma',
  code: 'relative_sentiment_score',
  value: '44'
}]